export const THEME_PREFERENCE_KEY = 'jira.user.theme.preference' as const;

export const THEME_PREFERENCES_ANALYTICS_SUBJECT = 'themePreference';
export const THEME_PREFERENCES_ANALYTICS_ACTION = 'changed';
